import produce from 'immer';
import { Reducer } from 'redux';
import { ThemeNameProps } from '../../themes';

const initialState = {};

type GlobalAction =
  | {
      type: 'globals/SET_SERVER_VARS';
      params: never;
    }
  | {
      type: 'globals/SET_DATEFORMAT';
      language: string;
      dateformat: string;
    }
  | {
      type: 'globals/SET_THEME';
      theme: ThemeNameProps;
    }
  | {
      type: 'globals/UPDATE_FOOTER';
      navigation: any[];
      socialMedia: any[];
      previewId: string;
      language: string;
    };

const reducer: Reducer<AppState['globals'], GlobalAction> = produce(
  (draft: AppState['globals'], action: GlobalAction) => {
    if ('language' in action && draft[action.language] === undefined) {
      draft[action.language] = {};
    }

    switch (action.type) {
      case 'globals/SET_SERVER_VARS':
        draft.server = action.params;
        break;

      case 'globals/SET_DATEFORMAT':
        draft[action.language].dateformat = action.dateformat;
        break;

      case 'globals/SET_THEME':
        draft.theme = action.theme;
        break;

      case 'globals/UPDATE_FOOTER':
        draft[action.language].footer.navigation = action.navigation;
        draft[action.language].footer.previewId = action.previewId;
        draft[action.language].socialMedia = action.socialMedia;
        break;

      default:
    }
  },
  initialState,
);

export default reducer;
